import {useQuery} from '@tanstack/vue-query';
import axios from 'axios';
import {isOnLocalDomain} from '@/composables/useLocalDomains';

const useBanners = () => useQuery({
    queryKey: ['banners', 'active'],
    queryFn: async () => {
        const {data} = await axios.get('/ajax/v2/banners/active');
        return data.data ?? [];
    },
    enabled: isOnLocalDomain,
});

export default useBanners;
